import { render, staticRenderFns } from "./boutiques.vue?vue&type=template&id=e1157178&"
import script from "./boutiques.vue?vue&type=script&lang=js&"
export * from "./boutiques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ILogoWordFlat: require('/opt/build/repo/components/svg/LogoWordFlat.vue').default,BoutiqueGrid: require('/opt/build/repo/components/BoutiqueGrid.vue').default})
